import script from "./PodcastAdminAlertRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastAdminAlertRoom.vue?vue&type=script&setup=true&lang=js"

import "./PodcastAdminAlertRoom.vue?vue&type=style&index=0&id=305cf357&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305cf357"]])

export default __exports__